import * as React from 'react';

import { PhoneButton } from '../../components/PhoneButton';
import { useCall } from '../../hooks';
import { useOfferContext } from '../OfferContext';

interface IPhoneButtonContainerProps {
  onClick?(): void;
}

export const PhoneButtonContainer: React.FC<IPhoneButtonContainerProps> = ({ onClick }) => {
  const { callButtonTitle } = useOfferContext();
  const { phone, handleCall, isCalltrackingEnabled } = useCall(onClick);

  if (!phone) {
    return null;
  }

  return <PhoneButton isCalltrackingEnabled={isCalltrackingEnabled} text={callButtonTitle} onClick={handleCall} />;
};
